import { render, staticRenderFns } from "./ReportTableDataRow.vue?vue&type=template&id=a63f2334"
import script from "./ReportTableDataRow.vue?vue&type=script&lang=js"
export * from "./ReportTableDataRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports